import { useEffect } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

import { JOIN_PARTNER_URL } from '@/features/join/pages/JoinPartnerPage'
import { AutocallForm, AutocallFormItem, CertPart } from '@/shared/components/Common/form'
import TelecomSelector from '@/shared/components/Common/form/TelecomSelector'
import { useCertOTP, useSendOTP, useUser } from '@/shared/hooks'
import { otpAuthType, otpCryptoNumber, otpTelecom } from '@/shared/recoil/otp/atom'
import { pNumAndCertNumWithValidate } from '@/shared/recoil/validate/withFormItem'
import { OtpCertFormContainer } from '@/styles/Common/form_styled'

const LoginPage = () => {
  const [pTelecom, setPTelecom] = useRecoilState(otpTelecom)
  const send = useSendOTP()
  const cert = useCertOTP()
  const { sticker } = useUser()
  const cryptoNumber = useRecoilValue(otpCryptoNumber)
  const pNumAndCertNumValid = useRecoilValue(pNumAndCertNumWithValidate)
  const setAuthType = useSetRecoilState(otpAuthType)

  const login = async () => {
    if (cryptoNumber.length > 0) {
      await cert.login()
      await sticker.check()
    }
  }

  useEffect(() => {
    setAuthType('login')
  }, [setAuthType])

  return (
    <AutocallForm>
      <OtpCertFormContainer>
        <h1>
          로그인을 위해 <br /> 본인인증을 진행해주세요.
        </h1>
        <section>
          <TelecomSelector telecom={pTelecom} setTelecom={setPTelecom} />
        </section>
        <AutocallFormItem title="" validate={pNumAndCertNumValid} essential>
          <CertPart
            onSendOTP={async () => await send.request()}
            onCertOTP={async () => await login()}
          />
        </AutocallFormItem>
        <button className="cancel_submit" onClick={login}>
          인증 완료
        </button>
        <p className="mypage_guide">
          오토콜 회원이 아니신가요?
          <span onClick={() => (window.location.href = JOIN_PARTNER_URL)}>회원가입</span>
        </p>
      </OtpCertFormContainer>
    </AutocallForm>
  )
}

export default LoginPage
